"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeBulkListeners = exports.removeListener = exports.addBulkListeners = exports.addListener = void 0;
/**
 * Add event listener to countr sdk
 * @param  {CountrSdk} sdk - Countr sdk
 * @param {CountrEventListener} - Listener obj (eventName, callback)
 */
const addListener = (sdk, event) => {
    sdk.ws.on(event.event, event.callback);
};
exports.addListener = addListener;
/**
 * Add bulk event listeners to countr sdk
 * @param  {CountrSdk} sdk - Countr sdk
 * @param {CountrEventListener} - Array of listeners obj (eventName, callback)
 */
const addBulkListeners = (sdk, events) => {
    events.forEach(({ event, callback }) => {
        sdk.ws.on(event, callback);
    });
};
exports.addBulkListeners = addBulkListeners;
/**
 * Remove event listener to countr sdk
 * @param  {CountrSdk} sdk - Countr sdk
 * @param {CountrEventListener} - Listener obj (eventName, callback)
 */
const removeListener = (sdk, event) => {
    sdk.ws.off(event.event, event.callback);
};
exports.removeListener = removeListener;
/**
 * Remove bulk event listeners to countr sdk
 * @param  {CountrSdk} sdk - Countr sdk
 * @param {CountrEventListener} - Array of listeners obj (eventName, callback)
 */
const removeBulkListeners = (sdk, events) => {
    events.forEach(({ event, callback }) => {
        sdk.ws.off(event, callback);
    });
};
exports.removeBulkListeners = removeBulkListeners;
